export default function SectionHeading({ eyebrow, title, subtitle, align = "center", gradientWord, className = "" }) {
    const alignClass = align === "left" ? "text-left" : "text-center mx-auto";
    return (
        <div className={`max-w-3xl ${alignClass} ${className}`}>
            {eyebrow && (
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-semibold uppercase tracking-wider border border-blue-100">
                    {eyebrow}
                </span>
            )}
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]">
                {gradientWord ? (
                    <>
                        {title}{" "}
                        <span className="gradient-text">{gradientWord}</span>
                    </>
                ) : (
                    title
                )}
            </h2>
            {subtitle && (
                <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                    {subtitle}
                </p>
            )}
        </div>
    );
}
